var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c("v-autocomplete", {
            attrs: {
              "data-cy": "FormRestaurantAdmin-userName",
              filled: "",
              label: _vm.$$t("userName"),
              "item-value": "username",
              "item-text": "username",
              items: _vm.restaurantAdminUsers,
            },
            model: {
              value: _vm.localRestaurantAdmin.userName,
              callback: function ($$v) {
                _vm.$set(_vm.localRestaurantAdmin, "userName", $$v)
              },
              expression: "localRestaurantAdmin.userName",
            },
          }),
          _c("v-autocomplete", {
            attrs: {
              "data-cy": "FormRestaurantAdmin-customerCode",
              filled: "",
              "item-text": "customerDesc",
              "item-value": "customerCode",
              label: _vm.$$t("customerCode"),
              items: _vm.customers,
            },
            model: {
              value: _vm.localRestaurantAdmin.customerCode,
              callback: function ($$v) {
                _vm.$set(_vm.localRestaurantAdmin, "customerCode", $$v)
              },
              expression: "localRestaurantAdmin.customerCode",
            },
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormRestaurantAdmin-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormRestaurantAdmin-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }